export default class Hook {
    #actionCallbacks = [];
    #filterCallbacks = [];

    constructor() {}

    addAction(hookName, callbackFunction, order = null) {
        if (typeof callbackFunction !== 'function') {
            throw new Error('Callback Function should be type of function. ' + (typeof callbackFunction) + ' given');
            return;
        }

        if (typeof this.#actionCallbacks[hookName] === 'undefined') {
            this.#actionCallbacks[hookName] = [];
        }

        if (this.#actionCallbacks[hookName].find(cb => cb === callbackFunction)) {
            throw new Error('This hook callback already added.');
            return;
        }

        if (order !== null){
            const callbackIndex = this.#actionCallbacks[hookName].findIndex(cb => cb.order > (order || 0));
            if (callbackIndex !== -1) {
                this.#actionCallbacks[hookName].splice(callbackIndex, 0, { callback: callbackFunction, order: order || 0});
            } else {
                this.#actionCallbacks[hookName].push({ callback: callbackFunction, order: order || 0});
            }
        } else {
            this.#actionCallbacks[hookName].push({ callback: callbackFunction, order: order || 0});
        }
    }

    removeAction(hookName, callbackFunction){
        const callbackIndex = this.#actionCallbacks[hookName]?.findIndex(cb => cb.callback === callbackFunction);

        this.#actionCallbacks[hookName]?.splice(callbackIndex, 1);
    }

    addFilter(hookName, callbackFunction, order = null) {
        if (typeof callbackFunction !== 'function') {
            throw new Error('Callback Function should be type of function. ' + (typeof callbackFunction) + ' given');
            return;
        }

        if (typeof this.#filterCallbacks[hookName] === 'undefined') {
            this.#filterCallbacks[hookName] = [];
        }

        if (this.#filterCallbacks[hookName].find(cb => cb === callbackFunction)) {
            throw new Error('This hook callback already added.');
            return;
        }

        if (order !== null){
            const callbackIndex = this.#filterCallbacks[hookName].findIndex(cb => cb.order > (order || 0));
            if (callbackIndex !== -1) {
                this.#filterCallbacks[hookName].splice(callbackIndex, 0, { callback: callbackFunction, order: order || 0});
            } else {
                this.#filterCallbacks[hookName].push({ callback: callbackFunction, order: order || 0});
            }
        } else {
            this.#filterCallbacks[hookName].push({ callback: callbackFunction, order: order || 0});
        }
    }

    removeFilters(hookName, callbackFunction){
        const callbackIndex = this.#filterCallbacks[hookName]?.findIndex(cb => cb.callback === callbackFunction);

        this.#filterCallbacks[hookName]?.splice(callbackIndex, 1);
    }

    getActionCallbacks(hookName) {
        return this.#actionCallbacks[hookName] || [];
    }

    getFilterCallbacks(hookName) {
        return this.#filterCallbacks[hookName] || [];
    }

    doAction(hookName, ...args) {
        for (const cb of this.getActionCallbacks(hookName)) {
            cb.callback(...args);
        }
    }

    applyFilters(hookName, ...args) {
		let value = args.shift();

        for (const cb of this.getFilterCallbacks(hookName)) {
			if (typeof cb.callback !== "function") continue;

			value = cb.callback(value, ...args);
        }

        return value;
    }
}
